export default __webpack_public_path__ + "locales/vi/SmartBanner.json?hash=505f42c8854e3770e4f121e5432a222f";